import api from "@/router/api";

export default {
  async getObjetivosAcao(acaoId) {
    const response = await api.get("/objetivos/acao", {
      params: { acaoId },
    });
    return response.data;
  },

  async getObjetivosAtividade(atividadeId) {
    const response = await api.get("/objetivos/atividade", {
      params: { atividadeId },
    });
    return response.data;
  },

  async deletarObjetivo(objetivoId) {
    const response = await api.delete(`/objetivos/${objetivoId}`);
    return response.data;
  },
};
